
import NavbarItem from "./navbar-item";
export default {
  components: { NavbarItem },
  data: () => ({
    active: "",
  }),
};
